
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="pt-24 min-h-[90vh] bg-gradient-to-br from-hero-blue to-hero-green flex items-center">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-12 items-center text-center">
          <div className="text-center animate-fade-in">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white leading-tight">
              Transformando empresas com <span className="text-hero-green-light">soluções de energia solar</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-white/90 max-w-xl mx-auto">
              Maximize sua eficiência energética e reduza custos operacionais com nossa plataforma completa de gestão de energia renovável.
            </p>
            <div className="flex items-center justify-center">
              <Link to="/login">
                <Button size="lg" className="bg-white text-hero-blue hover:bg-gray-100 text-lg py-6 px-8 rounded-lg shadow-lg">
                  Comece Agora
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
            <p className="mt-8 text-lg text-white/80">
              Economize até <span className="text-hero-green-light font-bold">95%</span> na conta de energia.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

